import { IExtraOptionPrototype } from "infrastructure/interfaces/IExtraMenuOption";

export default {
    action(context) {
        window.open(context.product.manualUrl);
    },
    icon: "fa fa-question-circle",
    title: "Инструкция",
} as IExtraOptionPrototype;
